import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { Security } from '@okta/okta-react'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'
import { oktaAuth } from '../../config/okta.config'
import { Router } from './Router'
import { AppsProvider, AuthProvider } from '../../contexts/'

const Root = () => {
  const history = useHistory()

  const restoreOriginalUri = useCallback(async (_oktaAuth: OktaAuth, originalUri: string) => {
    history.replace(toRelativeUrl(originalUri || '/', window.location.origin))
  }, [])

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <AuthProvider>
        <AppsProvider>
          <Router />
        </AppsProvider>
      </AuthProvider>
    </Security>
  )
}

export { Root }
